import TableTab3 from "./TableTab3";
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab3 = ({ItemGroupName, setselected_tax_item_data, selected_tax_item_data }) => {

  return (
    <div>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Item Tax</p>
        </div>



        <TableTab3 setselected_tax_item_data={setselected_tax_item_data} selected_tax_item_data={selected_tax_item_data} />


      </div>
      <div>
        <div>
          <ActivityCard doctype={'Item Group'} docname={'Ban'} />
        </div>
      </div>
    </div>
  )
}

export default Tab3